import { isAssetDto } from '@/entities/assets';
import { isPrivateDocumentDto } from '@/entities/document';

import { EntitiesToExtract } from './types';

export const collectionKind = {
  assets: 'asset',
  personalIdentifiers: 'id_document',
  privateDocuments: 'personal_document',
} as const;

export const isExtractionTypeEntity = (entity: EntitiesToExtract) => {
  // TODO: use type guard after the whole implementing PersonalIdentifierDocumentDtoV2
  return isAssetDto(entity) || 'personalIdentifierType' in entity || isPrivateDocumentDto(entity);
};
